<div class="d-flex">
  <div class="ml-2 mb-n1" [hidden]="!((allowedOrgs$ | async)?.length > 0)">
    <button
      class="menu-button org-menu-button"
      mat-button
      [disabled]="(allowedOrgs$ | async)?.length <= 1"
      [matMenuTriggerFor]="orgMenu"
    >
      <div class="d-flex flex-row">
        <span class="align-self-end">{{
          (currentSelectedOrg$ | async)?.clientName
        }}</span>
        <fa-icon
          class="primary align-self-center ml-2"
          *ngIf="(allowedOrgs$ | async)?.length > 1"
          [icon]="['fas', 'caret-down']"
          size="lg"
        ></fa-icon>
      </div>
    </button>
    <mat-menu #orgMenu="matMenu" class="selection-pane primary-menu">
      <div
        *ngFor="let allowedOrg of allowedOrgs$ | async"
        mat-menu-item
        (click)="selectOrg(allowedOrg, false)"
        [ngClass]="{ active: allowedOrg === (currentSelectedOrg$ | async) }"
      >
        <span class="text-ellipsis">{{ allowedOrg.clientName }}</span>
      </div>
    </mat-menu>
  </div>

  <div
    *ngIf="!hideSites && (allowedSites$ | async)?.length > 0"
    class="mr-auto mb-n1"
  >
    <button
      class="menu-button site-menu-button border-left-0"
      mat-button
      [disabled]="(allowedSites$ | async)?.length <= 1"
      [matMenuTriggerFor]="siteMenu"
    >
      <div class="d-flex flex-row">
        <span class="align-self-end">
          {{ (currentSelectedSite$ | async)?.siteName }}</span
        >
        <fa-icon
          class="primary align-self-center ml-2"
          *ngIf="(allowedSites$ | async)?.length > 1"
          [icon]="['fas', 'caret-down']"
          size="lg"
        ></fa-icon>
      </div>
    </button>
    <mat-menu #siteMenu="matMenu" class="selection-pane primary-menu">
      <div
        *ngFor="let siteOption of siteOptionsSource | async"
        mat-menu-item
        (click)="selectSites(siteOption)"
        [ngClass]="{
          active: siteOption?.isSelected
        }"
      >
        <mat-icon
          *ngIf="siteOption.isFavourite; else notFavourite"
          class="favourite-site-option"
          [ngClass]="siteOption.class"
          [class.disabled]="this.changingDefaultSiteSource | async"
          (click)="favouriteSite(siteOption, $event)"
          >star</mat-icon
        >
        <ng-template #notFavourite>
          <mat-icon
            *ngIf="!siteOption.isFavourite"
            class="favourite-site-option"
            [ngClass]="siteOption.class"
            [class.disabled]="this.changingDefaultSiteSource | async"
            (click)="favouriteSite(siteOption, $event)"
            >star_outlined</mat-icon
          >
        </ng-template>
        <span class="text-ellipsis">{{ siteOption.siteName }}</span>
      </div>
    </mat-menu>
  </div>
</div>
